<div *ngIf="pdfExportActive" class="row export-panel form-group no-gutters">
	<form class="form mt-3" role="form">
		<div class="row checkboxes">
			<div class="col-6">
				<mat-checkbox
					(change)="selectAll($event.checked)"
					[(ngModel)]="exportAll"
					[indeterminate]="isIndeterminate"
					[ngModelOptions]="{ standalone: true }"
					class="col-10"
					style="text-decoration: underline"
					>{{ 'project.selectAll' | translate }}
				</mat-checkbox>
			</div>
			<div class="col-6">
				<mat-radio-group
					(change)="docTypeChange($event)"
					[(ngModel)]="docExportType"
					[ngModelOptions]="{ standalone: true }"
					[value]="docExportType"
					class="d-flex col-12 mt-0 justify-content-end"
				>
					<mat-radio-button [value]="'pdf'" style="margin-left: 12px">
						{{ 'pdf' }}
					</mat-radio-button>
					<mat-radio-button *appHasLimits="[profileLimitKey.DOC_X_REPORTS]" [value]="'docx'" style="margin-left: 12px">
						{{ 'docx' }}
					</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>
	</form>
</div>

<div *ngIf="project && (isLoading$ | async)" class="spinner">
	<div class="spinner-inner">
		<mat-spinner color="accent"></mat-spinner>
	</div>
</div>

<div
	*ngIf="project"
	[class.pdf-export-enabled]="isPdfExportEnabled$ | async"
	[ngClass]="getChatContentClass$ | async"
	class="chat-content d-flex flex-grow-1 no-gutters with-new-chat-view w-100"
>
	<div
		(filesChanged)="onFilesChange($event)"
		*ngIf="!isFolder"
		[ngClass]="tagsVisible ? 'col-8' : 'col-12'"
		appDnd
		class="chat-drag-drop col d-flex flex-column flex-grow-1 h-100"
		dropzone="move"
	>
		<ng-container *ngIf="!isFolder">
			<div class="row no-gutters px-3 py-2 bg-white chat-search-container">
				<app-chat-search *ngIf="project" [chatFilterMenuContainer]="chatFilterMenuContainer" [project]="project" class="d-flex col">
				</app-chat-search>
				<div *ngIf="userCanExportChat$ | async" class="col-auto d-flex align-items-center invert-color pt-2">
					<a (click)="goToPDFExportToggle()" href="javascript:void(0)">
						<ng-container>
							<img [class.d-none]="isPdfExportEnabled$ | async" alt="export-icon" src="assets/images/icons/chat/export-icon.svg" />
							<img
								[class.d-none]="!(isPdfExportEnabled$ | async)"
								alt="export-icon-active"
								src="assets/images/icons/chat/export-icon-active.svg"
							/>
						</ng-container>
					</a>
				</div>
			</div>
			<div id="chat-filter-menu">
				<div #chatFilterMenuContainer="appViewContainer" appViewContainer></div>
			</div>
		</ng-container>

		<div class="drag-content" dropzone="move">{{ 'chat.drop' | translate }}</div>

		<div [class.with-pdf-export]="isPdfExportEnabled$ | async" class="d-flex flex-column flex-grow-1 message-container">
			<div
				#messageContainer
				(onScroll)="scrollEvent($event)"
				(paste)="onPaste($event)"
				*ngIf="!isFolder"
				appAutoScroll
				class="flex-grow-1 pb-3 px-3 overflow-auto message-content"
				data-cy="chat-middle-frame"
				detect-scroll
				lock-y-offset="20"
				observe-attributes
			>
				<ng-container *ngFor="let message of chatMessages$ | async; trackBy: chatMessageTrackBy">
					<div *ngIf="getMessageDate$(message) | async as stickyDate" class="message-date sticky-top pt-4 pb-3">
						<span>{{ stickyDate | messageDate }}</span>
					</div>
					<app-chat-message
						(getFile)="getFile($event)"
						(goToTagging)="goToTagging($event)"
						(gotToParent)="goToParentMessage($event)"
						(messageSelected)="handleMessageSelection($event.messageId, $event.isSelected)"
						(replyTo)="replyToMessage($event)"
						(shareMessageToFile)="shareMessageToFile($event)"
						(showImage)="showFile($event)"
						(showPdf)="showFile($event)"
						(showVideo)="showFile($event)"
						*ngIf="!pdfExportActive || (pdfExportActive && canBeExported(message))"
						[attr.id]="message.id"
						[company]="company"
						[exportAll]="exportAll"
						[exportList]="exportList"
						[file]="files[message.id]"
						[files]="files"
						[isPreviewAvailable]="checkPreviewAvailablity(message)"
						[messageDates]="messageDates"
						[messageSend]="isTextMessageSend(message)"
						[message]="message"
						[ngClass]="{ animate__flash: message.id === (selectedParentMessage$ | async) }"
						[pdfExportActive]="pdfExportActive"
						[project]="project"
						data-cy="chat-message"
					>
					</app-chat-message>
				</ng-container>

				<ng-template [ngIf]="!(chatMessages$ | async).length">
					<app-empty-state [type]="type"></app-empty-state>
				</ng-template>
			</div>
			<div *ngIf="!isFolder && !pdfExportActive" class="w-100 pt-2 px-3">
				<div *ngIf="isSearchedOrFiltered$ | async; then searchText; else chatMessageForm"></div>
			</div>
		</div>

		<div *ngIf="!isFolder && pdfExportActive" class="row footer-export no-gutters w-100">
			<div class="footer-export__buttons bg-primary col-12">
				<div class="row no-gutters">
					<div class="col-12">
						<button (click)="exportToPdf()" [disabled]="isLoading$ | async" class="text-white" mat-stroked-button>
							{{ 'project.report' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div [ngClass]="tagsVisible ? 'col-4' : 'col-0'" class="col p-0 h-100">
		<ng-container *ngIf="project && tagsVisible" [ngTemplateOutlet]="tagsView"></ng-container>
	</div>
</div>

<ng-template #searchText>
	<div class="row h-100">
		<div class="col-12 filter-padding">
			<span>{{ 'project.search.result' | translate }}</span>
			<span>{{ 'project.search.term' | translate }}{{ getSearchText$ | async }} </span>
			<strong (click)="clearSearchAndFilter()" class="clear-text pointer" data-cy="chat-clear-search">
				{{ 'project.search.chatClearAllFilters' | translate }}
			</strong>
		</div>
	</div>
</ng-template>

<ng-template #sendMessageForm>
	<form>
		<div class="row h-100 send-message-form align-items-end">
			<label [ngClass]="{ invisible: replyMessage$ | async }" class="col-auto text-center send-message-form__attachment" for="file">
				<em class="material-icons icon pointer">attach_file</em>
				<input (change)="fileEvent($event)" hidden id="file" multiple name="file" type="file" />
			</label>
			<div class="col">
				<div class="input-group input-height align-items-end">
					<div class="w-100">
						<ng-container [ngTemplateOutlet]="replyMessageTemplate"></ng-container>
						<textarea
							#chatMessageInput
							(keydown.enter)="sendMessage(MessageType.TEXT)"
							[(ngModel)]="content"
							[ngClass]="{ 'remove-border-top-radius': replyMessage$ | async }"
							autocomplete="off"
							class="input-message"
							id="message"
							maxlength="10000"
							name="message"
							placeholder="{{ 'chat.placeholder' | translate }}"
							rows="2"
							type="text"
						></textarea>
					</div>
					<button #emojiMenu="matMenuTrigger" [matMenuTriggerFor]="emojiContainer" class="chat-button ml-2">
						<em class="material-icons icon pointer">mood</em>
					</button>
					<button (click)="sendMessage(MessageType.TEXT)" class="chat-button last ml-2">
						<em class="material-icons icon pointer">send</em>
					</button>
				</div>
				<p class="m-0 send-hint grey-both">{{ 'chat.send.hint' | translate }}</p>
			</div>
		</div>
	</form>
</ng-template>

<mat-menu #emojiContainer yPosition="above">
	<div appEventStopPropagation class="emoji-container">
		<emoji-mart
			(emojiSelect)="onEmojiSelect($event)"
			[darkMode]="isDarkTheme$ | async"
			[i18n]="emojiTranslatedKeys"
			[showPreview]="false"
			emoji="point_up"
			isNative="true"
			set="google"
			title="Pick your emoji…"
		></emoji-mart>
	</div>
</mat-menu>

<ng-template #replyMessageTemplate>
	<div *ngIf="replyMessage$ | async as replyMessage" class="send-message-form__message pb-3">
		<app-reply-message [file]="files[replyMessage.id]" [replyMessage]="replyMessage">
			<div class="row no-gutters">
				<div class="col-11 font-weight-bold">
					{{ 'chat.reply.replying-to' | translate: { name: replyMessage.author } }}
				</div>
				<div class="col-1 text-right">
					<mat-icon (click)="clearReplyMessage()" class="pointer">close</mat-icon>
				</div>
			</div>
		</app-reply-message>
	</div>
</ng-template>

<ng-template #tagsView>
	<app-tagging-action-dialog
		(close)="onCloseTagsDialog()"
		[company]="company | async"
		[message]="tagsActiveMessage"
		[project]="project"
	></app-tagging-action-dialog>
</ng-template>

<ng-template #chatMessageForm>
	<div class="d-flex mb-1 align-items-end">
		<div class="d-flex flex-grow-1 flex-column">
			<ng-container [ngTemplateOutlet]="replyMessageTemplate"></ng-container>
			<mat-form-field appearance="fill" class="flex-grow-1">
				<textarea
					#autosize="cdkTextareaAutosize"
					#chatMessageInput
					(keydown.enter)="sendMessage(MessageType.TEXT, $event)"
					(keyup)="updateInputCache()"
					(paste)="onPaste($event)"
					[(ngModel)]="content"
					cdkAutosizeMaxRows="5"
					cdkAutosizeMinRows="1"
					cdkTextareaAutosize
					class="m-0 p-0 message-textarea"
					data-cy="chat-input-box"
					matInput
					placeholder="{{ 'chat.placeholder' | translate }}"
				></textarea>
			</mat-form-field>
		</div>
		<div class="d-flex chat-buttons">
			<button
				(click)="inputFile.click()"
				[disabled]="replyMessage$ | async"
				class="ml-2 px-2 pb-1"
				data-cy="chat-attach-file"
				mat-stroked-button
			>
				<mat-icon>attach_file</mat-icon>
				<input #inputFile (change)="fileEvent($event)" hidden id="file" multiple name="file" type="file" />
			</button>
			<button
				#emojiMenu="matMenuTrigger"
				[matMenuTriggerFor]="emojiContainer"
				class="mx-2 px-2"
				data-cy="chat-smilie-icon"
				mat-stroked-button
			>
				<mat-icon>mood</mat-icon>
			</button>
			<button (click)="sendMessage(MessageType.TEXT)" class="px-3" color="accent" data-cy="chat-send-message" mat-flat-button>
				<mat-icon class="mx-3">send</mat-icon>
			</button>
		</div>
	</div>
	<div [innerHTML]="'chat.send.hint' | translate" class="m-0 send-hint grey-both"></div>
</ng-template>
